var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.671,
    height: 25.327,
    viewBox: "0 0 22.671 25.327",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#304044}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_215",
    transform: "translate(-49.731 -25.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_78",
    d: "M142.935 38.752a6.576 6.576 0 1 0-6.576-6.576 6.593 6.593 0 0 0 6.576 6.576z",
    className: "cls-1",
    transform: "translate(-81.866)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_79",
    d: "M72.354 278.225a6.128 6.128 0 0 0-.66-1.206 8.174 8.174 0 0 0-5.657-3.561 1.211 1.211 0 0 0-.833.2 7.009 7.009 0 0 1-8.27 0 1.078 1.078 0 0 0-.833-.2 8.114 8.114 0 0 0-5.657 3.561 7.07 7.07 0 0 0-.66 1.206.61.61 0 0 0 .029.546 11.45 11.45 0 0 0 .775 1.149 10.915 10.915 0 0 0 1.321 1.493 17.223 17.223 0 0 0 1.321 1.149 13.095 13.095 0 0 0 15.621 0 12.627 12.627 0 0 0 1.321-1.149 13.248 13.248 0 0 0 1.321-1.493 10.063 10.063 0 0 0 .775-1.149.49.49 0 0 0 .086-.546z",
    className: "cls-1",
    transform: "translate(0 -234.219)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.d176ddcc32f1402e31dd0ee03b751025.svg";
export { ForwardRef as ReactComponent };